export const CHART_COLORS = ['#4A90E2', '#F5A623', '#259D92', '#BD10E0', '#FF470F', '#50E3C2', '#701251'];

export const KNOWN_ACRONYMS = ['CPA', 'ROAS', 'CPC', 'CPM', 'CTR', 'ROI', 'ACOS'];

/**
 * Convierte snake_case a Title Case, respetando acronyms conocidos.
 * Ej: "costo_total" → "Costo Total", "cpc" → "CPC"
 */
export function formatMetricName(name) {
    return name
        .replace(/_/g, ' ')
        .replace(/\w\S*/g, (word) => {
            const upper = word.toUpperCase();
            if (KNOWN_ACRONYMS.includes(upper)) return upper;
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
}

/**
 * Detecta si un string es una fecha en formato YYYYMMDD.
 */
export function isDateValue(value) {
    return typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value);
}

/**
 * Convierte YYYYMMDD → DD/MM/YYYY. Retorna el valor original si no es fecha.
 */
export function formatDateLabel(label) {
    if (isDateValue(label)) {
        return `${label.slice(6, 8)}/${label.slice(4, 6)}/${label.slice(0, 4)}`;
    }
    return label;
}

/**
 * Infiere el formato de display de un campo basado en su nombre.
 * Misma lógica que _infer_format en template_report_service.py del backend.
 */
export function inferFormat(fieldName) {
    const lower = fieldName.toLowerCase();
    if (['costo', 'cpc', 'cpm', 'cpa', 'ingreso', 'revenue', 'valor', 'precio', 'aov'].some(kw => lower.includes(kw))) {
        return 'currency';
    }
    if (['tasa', 'ctr', 'rate', 'porcentaje', 'acos'].some(kw => lower.includes(kw))) {
        return 'percentage';
    }
    return 'number';
}

/**
 * Formatea un valor numérico según su formato.
 */
export function formatValue(value, format) {
    if (value === null || value === undefined) return '-';

    switch (format) {
        case 'currency':
            return new Intl.NumberFormat('es-AR', {
                style: 'currency',
                currency: 'ARS',
                minimumFractionDigits: 2
            }).format(value);
        case 'percentage':
            return `${value.toFixed(2)}%`;
        case 'number':
        default:
            return new Intl.NumberFormat('es-AR').format(value);
    }
}

